var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1739_14712)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.975098,
    width: 25,
    height: 25,
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3624 22.4031C10.9811 22.4031 12.2961 21.0705 12.2961 19.4269V16.4507H9.3624C7.74371 16.4507 6.42871 17.7833 6.42871 19.4269C6.42871 21.0705 7.74371 22.4031 9.3624 22.4031Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.42871 13.4752C6.42871 11.8331 7.74371 10.499 9.3624 10.499H12.2961V16.4515H9.3624C7.74371 16.4515 6.42871 15.1188 6.42871 13.4752Z",
    fill: "#A259FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.42871 7.5226C6.42871 5.88045 7.74371 4.54639 9.3624 4.54639H12.2961V10.4988H9.3624C7.74371 10.4988 6.42871 9.16621 6.42871 7.5226Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2961 4.54639H15.2298C16.8485 4.54639 18.1635 5.88045 18.1635 7.5226C18.1635 9.16621 16.85 10.4988 15.2298 10.4988H12.2961V4.54639Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1635 13.4752C18.1635 15.1188 16.85 16.4515 15.2298 16.4515C13.6097 16.4515 12.2961 15.1188 12.2961 13.4752C12.2961 11.8331 13.6097 10.499 15.2298 10.499C16.85 10.499 18.1635 11.8331 18.1635 13.4752Z",
    fill: "#1ABCFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1739_14712"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.975098,
    width: 25,
    height: 25,
    rx: 5,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/Figma.b0bdd927f9191629e11e89ad6fcf586c.svg";
export { ForwardRef as ReactComponent };